import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@coreui/coreui/dist/css/coreui.min.css';
import App from './App'; // Importa tu componente raíz
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App /> {/* Aquí montas tu aplicación */}
  </React.StrictMode>
);

reportWebVitals();
